import type { CalculationResult } from '../../../derived-state/CalculationResult';
import type { ShortCircuitProperty } from '../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import type { ElectricCurrentType } from '../../../domain/ElectricCurrent';
import type { EvaluatedResult } from '../../EvaluatedResult';
import type { ForShortCircuitEvaluation } from '../engines/ForShortCircuitEvaluation';

export type EvaluatedElectricCurrentType = CalculationResult<{
  min: EvaluatedResult<ElectricCurrentType>;
  max: EvaluatedResult<ElectricCurrentType>;
}>;

export class EvaluatedElectricCurrentSummary {
  static from(
    evaluate: ForShortCircuitEvaluation,
    min: ShortCircuitProperty,
    max: ShortCircuitProperty
  ): EvaluatedElectricCurrentType {
    if (
      min.faultCurrent.toAmperes() === 0 ||
      max.faultCurrent.toAmperes() === 0
    ) {
      return {
        type: 'CALCULATION_RESULT_NOT_AVAILABLE'
      };
    }
    return {
      type: 'CALCULATION_RESULT_AVAILABLE',
      result: {
        min: evaluate(min),
        max: evaluate(max)
      }
    };
  }
}
